import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { DataLayer } from '../../common/datalayer/datalayer';
import { ApplicationConfig } from '../../config/config';
import { FlyoutLangselectorComponent } from '../../flyout/flyout-langselector/flyout-langselector.component';
import { ContentCountryLanguage } from '../../model/content/contentCountryLanguage.model';
import { ContentFooter } from '../../model/content/contentfooter.model';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { CountryLanguageService } from '../../services/country_Language/country_Language.service';
import { CountryLanguageHelper } from '../country-language-helper';

declare let rhpr: any;

@Component({
  selector: 'ngc-language-selector',
  templateUrl: './language-selector.component.html'
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
  @ViewChild('triggerElement') triggerElement: ElementRef;
  @Input('isHamberger') isHamberger;
  bsModalRef: BsModalRef;
  config = {
    animated: false
  };

  countryLanguageContent: ContentCountryLanguage;
  contentHeaderFooterServiceSubscribe: Subscription;
  modalServiceOnHiddenSubscribe: Subscription;
  prefLanguage: any;
  secondaryPrefLanguage: any;
  contentFooter: ContentFooter;
  private countryName = 'United States';
  private langCode = 'EN';
  private countryLanguageList: any = [];

  private prefCookieValue: any;
  private unsubscribe: Subject<void> = new Subject();
  private langselector: any;
  private countryslector: any;
  // private player: AnimationPlayer;
  // private animationTime: string = '300ms';

  constructor(
    private modalService: BsModalService,
    private changeDetection: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    private countryLangSvc: CountryLanguageService,
    private cookieHelper: CookieHelper,
    private datalayer: DataLayer,
    private countryLanguageHelper: CountryLanguageHelper,
    public el: ElementRef,
    private renderer: Renderer2,
    private dragModal: CommonService,
    // private _builder: AnimationBuilder,
    private appconfig: ApplicationConfig,
    private loggingService: LoggingService
  ) {}

  ngOnInit() {
    this.contentService._isHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((headerFooterFlag) => {
        if (headerFooterFlag) {
          if (this.contentService.contentHeaderFooter) {
            const prefValue = this.countryLanguageHelper.prefCookie;
            if (!prefValue) {
              this.countryLanguageHelper.setPreferedLanguages(
                this.appconfig.get('APP_PREF_COOKIE')
              );
            }
            this.contentHeaderFooterServiceSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (data) => {
                    if (data) {
                      this.countryLanguageContent = data.footer.countryLanguage;
                      this.contentFooter = data.footer;
                      this.changeDetection.detectChanges();
                      this.countryLangSvc
                        .countryLanguageDataFromAPI()
                        .pipe(takeUntil(this.unsubscribe))
                        .subscribe((countryLanguageData) => {
                          if (countryLanguageData) {
                            this.countryLanguageHelper
                              .getPreferedLangagues()
                              .pipe(takeUntil(this.unsubscribe))
                              .subscribe((prefCountry) => {
                                if (prefCountry) {
                                  this.countryLanguageHelper.setData(
                                    countryLanguageData
                                  );
                                  this.countryLanguageList =
                                    this.countryLanguageHelper.getCountryLanguageList();
                                  this.prefCookieValue = prefCountry;
                                  if (
                                    this.prefCookieValue &&
                                    this.prefCookieValue.length > 0
                                  ) {
                                    const res = this.prefCookieValue.split('-');
                                    // For Hamburger Language Selector
                                    this.langCode = res[0].toUpperCase();
                                    this.countryslector = res[1].toLowerCase();

                                    // For Language Selector in footer
                                    const country =
                                      this.countryLanguageHelper.getCountryForCountryCode(
                                        res[1]
                                      );
                                    const primarylang =
                                      this.countryLanguageHelper.getLangaugeForLanguageCode(
                                        res[1],
                                        res[0]
                                      );
                                    if (country.countryName) {
                                      this.countryName = country.countryName;
                                    }
                                    if (primarylang) {
                                      this.prefLanguage = primarylang;
                                      this.secondaryPrefLanguage =
                                        this.countryLanguageHelper.getSecondaryLanguageForSelectedLanguage(
                                          res[1],
                                          res[0]
                                        );
                                    }
                                  }
                                  this.changeDetection.detectChanges();
                                }
                              });
                          }
                        });
                    }
                  },
                  (err) => {
                    this.loggingService.log('Caught Error: ' + err);
                  }
                );
          }
        }
      });
  }

  setTrackingObject(e) {
    this.datalayer.setTrackingObjectProp1(
      'footer:country and language',
      e.target
    );
  }

  open() {
    const disableCLS =
      this.appconfig.get('APP_DISABLE_CLS2') &&
      this.appconfig.get('APP_DISABLE_CLS2') === 'true'
        ? true
        : false;
    if (!disableCLS) {
      const bodyScroll = document.documentElement.scrollTop;
      let obj;
      obj = Object.assign({}, this.config, { class: 'lang-modal' });
      this.bsModalRef = this.modalService.show(
        FlyoutLangselectorComponent,
        obj
      );
      // this.animateCLSModal();
      this.bsModalRef.content.countryLanguageContent =
        this.countryLanguageContent;
      this.bsModalRef.content.dialog.nativeElement.focus();
      const htmlRoot = document.getElementsByTagName('html')[0];
      if (!(htmlRoot.className.indexOf('no-scroll') >= 0)) {
        htmlRoot.className += ' no-scroll';
      }
      this.modalServiceOnHiddenSubscribe = this.modalService.onHidden
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (reason: string) => {
            this.triggerElement.nativeElement.focus();
            this.modalServiceOnHiddenSubscribe.unsubscribe();
          },
          (err) => {
            this.loggingService.log('Caught Error: ' + err);
          }
        );
      this.dragModal.dragModalContainers(this.el, this.renderer);
      document.documentElement.scrollTop = bodyScroll;
      this.dragModal.focusModalContainers(this.el, this.renderer);
      this.adjustModalPosition(bodyScroll);
    }
  }

  adjustModalPosition(bodyScroll) {
    this.renderer.setStyle(document.body, 'position', 'static');
    window.scrollTo(0, bodyScroll);
    const modalEle = document.getElementsByTagName('modal-container');
    if (modalEle && modalEle[0]) {
      this.renderer.setStyle(modalEle[0], 'position', 'fixed');
    }
    this.renderer.setStyle(
      document.getElementsByTagName('html')[0],
      'overflow',
      'hidden'
    );
  }

  // animateCLSModal() {
  //   if (this.player) {
  //     this.player.destroy();
  //   }
  //   const factory = this._builder.build([
  //     style({ visibility: 'visible', opacity: 0 }),
  //     animate((this.animationTime + ' ease-out'), style({ opacity: 1 }))
  //   ]);
  //   this.player = factory.create(document.getElementsByClassName('lang-modal-content')[0], {});
  //   this.player.play();
  // }

  ngOnDestroy() {
    if (this.contentHeaderFooterServiceSubscribe) {
      this.contentHeaderFooterServiceSubscribe.unsubscribe();
    }
    if (this.modalServiceOnHiddenSubscribe) {
      this.modalServiceOnHiddenSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.changeDetection.detach();
  }

  changeLanguage() {
    this.langselector = this.secondaryPrefLanguage.languageCode;
    const prefValue =
      this.secondaryPrefLanguage.languageCode + '-' + this.countryslector;
    // this.countryLanguageHelper.setPreferedLanguages(prefValue);
    this.cookieHelper.setCookies('prefUI', prefValue);
    // let temp = this.secondaryPrefLanguage;
    // this.secondaryPrefLanguage = this.prefLanguage;
    // this.prefLanguage = temp;
    if ('undefined' !== typeof rhpr && rhpr === true) {
      this.countryLanguageHelper.redirectToTranslatedSites(
        this.countryslector,
        this.langselector
      );
    } else {
      this.countryLanguageHelper.redirectToTranslatedSitesForContentPages(
        this.countryslector,
        this.langselector
      );
    }
  }
}
